import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

export class WebHookService extends BaseService {
  static async checkHooks(options) {
    try {
      const response = await this.request({ auth: true }).post('web-hooks/check-hooks', { ...options });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async setHook(options) {
    try {
      const response = await this.request({ auth: true }).post('web-hooks/set-hook', { ...options });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }

  static async deleteHook(options) {
    try {
      const response = await this.request({ auth: true }).post('web-hooks/delete-hook', { ...options });

      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
}
